// ----------------------------------------------------------------------
// <copyright file="Izenda.Components.js" company="Izenda">
//  Copyright (c) 2015 Izenda, Inc.
//  ALL RIGHTS RESERVED
//
//  The entire contents of this file is protected by U.S. and
//  International Copyright Laws. Unauthorized reproduction,
//  reverse-engineering, and distribution of all or any portion of
//  the code contained in this file is strictly prohibited and may
//  result in severe civil and criminal penalties and will be
//  prosecuted to the maximum extent possible under the law.
//
//  RESTRICTIONS
//
//  THIS SOURCE CODE AND ALL RESULTING INTERMEDIATE FILES
//  ARE CONFIDENTIAL AND PROPRIETARY TRADE
//  SECRETS OF IZENDA INC. THE REGISTERED DEVELOPER IS
//  LICENSED TO DISTRIBUTE THE PRODUCT AND ALL ACCOMPANYING .NET
//  CONTROLS AS PART OF AN EXECUTABLE PROGRAM ONLY.
//
//  THE SOURCE CODE CONTAINED WITHIN THIS FILE AND ALL RELATED
//  FILES OR ANY PORTION OF ITS CONTENTS SHALL AT NO TIME BE
//  COPIED, TRANSFERRED, SOLD, DISTRIBUTED, OR OTHERWISE MADE
//  AVAILABLE TO OTHER INDIVIDUALS WITHOUT EXPRESS WRITTEN CONSENT
//  AND PERMISSION FROM IZENDA INC.
//
//  CONSULT THE END USER LICENSE AGREEMENT(EULA FOR INFORMATION ON
//  ADDITIONAL RESTRICTIONS.
// </copyright>
// ----------------------------------------------------------------------

import ReportPartTypeManager from '../Izenda.ReportPartTypeManager';
import Validator from 'share/components/hoc/Izenda.Validator';
import Localizer from '../share/localization/Izenda.Localizer';
import React from 'react';
import { extendObservable, action } from 'mobx';
import { observer } from 'mobx-react';

/**
 * Export the using Izenda components and 3rd party lib that would be useful to create custom Izenda components
 */
export default {
  /**
   * React lib
   */
  React,
  /**
   * A higher order function to create observable React component
   */
  observableReact: observer,
  /**
   * Observe an instance with observable properties
   */
  observableObject: extendObservable,
  /**
   * A higher order function to create observable action to apply all changes to observable object in one commit
   */
  observableAction: action,
  /**
   * Register a custom report part type
   */
  ReportPartTypeManager,
  /**
   * Register a new language text
   */
  Localizer,
  /**
   * A higher order component to create a validatable component that works with validation UI inside Izenda app
   */
  Validator
};



// WEBPACK FOOTER //
// ./ui/api/Izenda.Components.js